const getInitialRedirection = (accesses) => {
  if (accesses.hasFullAccess) {
    return "/dashboard"
  }

  if (!!accesses["viewDashboard"]) {
    return "/dashboard"
  }

  if (!!accesses["viewLatestOrders"]) {
    return "/orders-paid"
  }

  if (!!accesses["viewOrderHistory"]) {
    return "/orders-delivered"
  }

  if (!!accesses["viewCanceledOrders"]) {
    return "/orders-canceled"
  }

  if (!!accesses["viewCanceledOrders"]) {
    return "/orders-canceled"
  }

  if (!!accesses["viewWalletTransactions"]) {
    return "/wallet-transactions"
  }

  if (!!accesses["viewFoodList"]) {
    return "/food-list"
  }

  if (!!accesses["viewSpecificationList"]) {
    return "/specification-list"
  }

  if (!!accesses["viewAddOnList"]) {
    return "/add-on-list"
  }

  if (!!accesses["viewCategories"]) {
    return "/categories"
  }

  if (!!accesses["inventory"]) {
    return "/inventory"
  }

  if (!!accesses["viewCouponsList"]) {
    return "/coupons"
  }

  if (!!accesses["viewCombosList"]) {
    return "/combo-list"
  }

  if (!!accesses["viewReports"]) {
    return "/reports"
  }

  if (!!accesses["viewShifts"]) {
    return "/shift-history"
  }

  if (!!accesses["viewPageDecoration"]) {
    return "/page-decoration"
  }

  if (!!accesses["viewSystemSettings"]) {
    return "/settings"
  }

  if (!!accesses["viewTaxList"]) {
    return "/taxes-and-charges"
  }

  if (!!accesses["viewCustomersList"]) {
    return "/customers"
  }

  if (!!accesses["viewAccessList"]) {
    return "/role-management"
  }

  if (!!accesses["viewStaff"]) {
    return "/account-management"
  }

  return ""
}

export default getInitialRedirection